import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxActivityViewComponent } from '@go-modules/components/activity-view/activity-view.component';

// TODO - remove when routesConfig ngx STAB-1182
export const ngxActivityViewModule = angular.module('ngxActivityViewModule', [])
	.directive('ngxActivityView', downgradeComponent({ component: NgxActivityViewComponent }))
	.name;
